import React, { useEffect } from 'react';
import { detectDeviceType, getStoreUrl } from '../utils/deviceDetection';

const ToStore: React.FC = () => {
  useEffect(() => {
    const deviceType = detectDeviceType();
    const storeUrl = getStoreUrl(deviceType);
    
    // Always redirect immediately - fastest possible
    window.location.href = storeUrl;
  }, []);

  // Should never be seen - redirect happens immediately
  return null;
};

export default ToStore;
